import initStore from './initStore';
import thunks from './thunks';
import actions from './actions';

import { IResourceModel } from './types';

const resource: IResourceModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default resource;
